import * as apiPrecedent from '@/api/precedent'

// 先例・判例関係
const precedent = {
  namespaced: true,
  state: {
    books: [], // 書籍セレクタ

    bookId: 0, // 先例・判例内容ID
    bookRevisionId: 0, // 先例・判例内容リビジョンID
    previewBookRevisionId: 0, // 管理画面からのプレビュー用リビジョンID
    bookName: '', // 書籍名
    subTitle: '', // 検索タイトル

    tab: 0, // 先例・判例画面のタブ

    themeId: 0, // 先例・判例テーマID
    themeName: '', // 先例・判例テーマ名

    detailId: 0, // 先例・判例詳細ID

    // 目次データ(ローカルストレージにキャッシュされる(/src/store/index.jsの変数saveStoragePathに指定))
    tocList: [],

    // 検索系
    searchSetting: {
      searchOrder: 'score',
      ascending: 'desc',
      per_page: 30
    },
    searchParams: {},
    searchPage: 1
  },
  getters: {
  },
  mutations: {
    setTab(state, tab) {
      state.tab = tab
    },
    setBooks(state, books) {
      state.books = books
    },
    setBookId(state, bookId) {
      state.bookId = bookId
    },
    setBookRevisionId(state, bookRevisionId) {
      state.bookRevisionId = bookRevisionId
    },
    setPreviewBookRevisionId(state, previewBookRevisionId) {
      state.previewBookRevisionId = previewBookRevisionId
    },
    setThemeId(state, themeId) {
      state.themeId = themeId
    },
    setThemeName(state, themeName) {
      state.themeName = themeName
    },
    clearBook(state) {
      state.bookId = 0
      state.bookRevisionId = 0
      state.previewBookRevisionId = 0
      state.bookName = ''
      state.subTitle = ''
    },
    setBookName(state, bookName) {
      state.bookName = bookName
    },
    setSubTitle(state, subTitle) {
      state.subTitle = subTitle
    },
    setDetailId(state, detailId) {
      state.detailId = detailId
    },
    setTOCList(state, tocList) {
      state.tocList = tocList
    },
    addTOCList(state, map) {
      const targetBookRevisionId = map.bookRevisionId
      // 念のため、同じ書籍リビジョンIDがあれば除外する処理をしておく
      const newTocList = []
      state.tocList.forEach((map2) => {
        const bookRevisionId = map2.bookRevisionId
        if (bookRevisionId !== targetBookRevisionId) {
          newTocList.push(map2)
        }
      })
      // 新しい要素の追加
      newTocList.push(map)
      state.tocList = newTocList
    },
    updateSearchSetting(state, setting) {
      state.searchSetting = { ...state.searchSetting, ...setting}
    },
    setSearchParams(state, searchParams) {
      state.searchParams = searchParams
    },
    setPage(state, page) {
      state.searchPage = page
    },
    clearAll(state) {
      state.books = []
      state.bookId = 0
      state.bookRevisionId = 0
      state.previewBookRevisionId = 0
      state.bookName = ''
      state.subTitle = ''
      state.tab = 0
      state.themeId = 0
      state.themeName = ''
      state.detailId = 0
      state.tocList = []
      state.searchSetting = {
        searchOrder: 'score',
        ascending: 'desc',
        per_page: 30
      }
      state.searchParams = {}
      state.searchPage = 1
    },
    clearTheme(state) {
      state.themeId = 0
      state.themeName = ''
    },
    clearDetail(state) {
      state.detailId = 0
    }
  },
  actions: {
    setTab({ commit }, tab) {
      commit('setTab', tab)
    },
    setBooks({ commit }, books) {
      commit('setBooks', books)
    },
    setBookId({ commit }, bookId) {
      commit('setBookId', bookId)
    },
    setBookRevisionId({ commit }, bookRevisionId) {
      commit('setBookRevisionId', bookRevisionId)
    },
    setPreviewBookRevisionId({ commit }, previewBookRevisionId) {
      commit('setPreviewBookRevisionId', previewBookRevisionId)
    },
    setThemeId({ commit }, themeId) {
      commit('setThemeId', themeId)
    },
    setThemeName({ commit }, themeName) {
      commit('setThemeName', themeName)
    },
    clearBook({ commit }) {
      commit('clearBook')
    },
    setBookName({ commit }, bookName) {
      commit('setBookName', bookName)
    },
    setSubTitle({ commit }, subTitle) {
      commit('setSubTitle', subTitle)
    },
    setDetailId({ commit }, detailId) {
      commit('setDetailId', detailId)
    },
    async addTOCList({ commit }, bookRevisionId) {
      if (bookRevisionId !== 0) {
        // 先例・判例目次APIをコール
        const params = {
          book_revision_id: bookRevisionId
        }
        return apiPrecedent.getTOC(params)
          .then(response => {
            const { data } = response

            // 設計書「【SHOWER】SNOL-PC-資料検索.xlsx」、「【SHOWER】SNOL-SP-資料検索.xlsx」内の
            // シート「(参考)資料検索のStore仕様」にあるデータ構造JSONの「pj > contents」要素の形式に加工する
            const map = {
              bookRevisionId,
              toc: data.list ?? [],
              errorFlag: (data.status !== 0) // 先例・判例目次取得APIが成功している場合はfalse、失敗した場合はtrueが入る
            }
            commit('addTOCList', map)
          })
      }
    },
    updateSearchSetting({ commit }, setting) {
      commit('updateSearchSetting', setting)
    },
    setSearchParams({ commit }, searchParams) {
      commit('setSearchParams', searchParams)
    },
    setPage({ commit }, page) {
      commit('setPage', page)
    },
    // 全ステートをクリア
    clearAll({ commit }) {
      commit('clearAll')
    },
    clearTheme({ commit }) {
      commit('clearTheme')
    },
    clearDetail({ commit }) {
      commit('clearDetail')
    }
  }
}

export default precedent
